<div class="InfoDetails">

        <!-- <div class="Loading"  *ngIf="isShowLoading==true">
       
                <img id="" src="assets/img/762.gif"   />
                <label>{{'Please Wait,Processing..'|translate }}</label>
        </div> -->
        <div class="Loading" *ngIf="isShowLoading==true">
                <div class="loader"></div>
                <!-- <img id="" src="assets/img/762.gif"   /> -->
                <label class="loaderlabel">Please wait while Processing....</label>
        </div>

        <div class="row form-group hidden-sm hidden-xs">

                <div class="row bs-wizard MotoWizard" style="border-bottom:0;">

                        <div class="col-xs-3 bs-wizard-step complete">
                                <div class="text-center bs-wizard-stepnum">{{ 'Step 1'| translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center">{{ 'Basic Info'| translate}}</div>
                        </div>

                        <div class="col-xs-3 bs-wizard-step " [ngClass]="!SecondStep?'complete':'active'">
                                <!-- complete -->
                                <div class="text-center bs-wizard-stepnum">{{'Step 2'| translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center"> {{'Insured'| translate }} & {{'Vehicle Details'| translate}}</div>
                        </div>

                        <div class="col-xs-3 bs-wizard-step " [ngClass]="!ThirdStep?'disabled':'complete'">
                                <!-- complete -->
                                <div class="text-center bs-wizard-stepnum">{{'Step 3'| translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center"> {{'Premium Details'| translate}}</div>
                        </div>

                        <div class="col-xs-3 bs-wizard-step " [ngClass]="!FourthStep?'disabled':'complete'">
                                <!-- complete -->
                                <div class="text-center bs-wizard-stepnum">{{'Step 4'| translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center"> {{'Review & Payment'| translate}}</div>
                        </div>


                </div>
        </div>

        <div class="row hidden-lg hidden-md" style="display:none;">
                <div class="stepwizard col-lg-12">
                        <div class="stepwizard-row setup-panel">
                                <div class="stepwizard-step">
                                        <a type="button" class="btn btn-primary btn-circle btnCompleted">1</a>
                                        <p>{{'Basic'| translate}}
                                                <br> {{'Information'| translate}}
                                        </p>
                                </div>
                                <div class="stepwizard-step">
                                        <a type="button" class="btn btn-default btn-circle " [ngClass]="!ReviewInfo?'btnprogress':'btnCompleted'">2</a>
                                        <p>Insured
                                                <br> & {{'Driver' | translate}}
                                        </p>
                                </div>
                                <div class="stepwizard-step">
                                        <a type="button" class="btn btn-default btn-circle" [ngClass]="ReviewInfo?'btnprogress':'dd'">3</a>
                                        <p>{{'Review' | translate }} &
                                                <br>{{'Payment' | translate }}
                                        </p>
                                </div>
                        </div>
                </div>
        </div>
        <!-- <div class="Clears"></div> -->

        <div class="row">

                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

                        <router-outlet></router-outlet>

                </div>



                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">


                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subchild">
                                <div class="card" style="width:100%;" id="InsuredInfo">
                                        <ul class="nav nav-tabs listdata" role="tablist">
                                                <li role="presentation" class="active">
                                                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{ 'Policy Info'| translate}}</a>
                                                </li>

                                        </ul>

                                        <div class="tab-content detailsTab">
                                                <div role="tabpanel" class="tab-pane active" id="home">
                                                        <div class="card" style="width:100%;">
                                                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                                                        <li role="presentation" class="active">
                                                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{ 'Policy Period Information'| translate}}</a>
                                                                        </li>

                                                                </ul>
                                                                <div class="tab-content">
                                                                        <div role="tabpanel" class="tab-pane active PolicyInfo" id="PolicyInfo">

                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Starting' | translate }}:</span>
                                                                                        <span> {{prObj.ProposalEffFrom | date: 'dd/MM/yyyy'
                                                                                                }}
                                                                                        </span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Ending' | translate }}:</span>
                                                                                        <span>{{prObj.ProposalEffTo | date: 'dd/MM/yyyy'}}</span>

                                                                                </label>
                                                                        </div>

                                                                </div>
                                                        </div>
                                                        <div class="card" style="width:100%;">
                                                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                                                        <li role="presentation" class="active">
                                                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Vehicle Information'| translate}}</a>
                                                                        </li>

                                                                </ul>
                                                                <div class="tab-content">

                                                                        <div role="tabpanel" class="tab-pane active PolicyInfo" id="home">

                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Use Of Vehicle'| translate}}: </span>
                                                                                        <span>{{Lng == "en"?prObj.vehcileObj.UseOfVehcileEn:prObj.vehcileObj.UseOfVehcileAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Plate No Arabic'| translate}}:</span>
                                                                                        <span>{{Lng == "en"?prObj.vehcileObj.Vehicle_FullPlateNoEn :prObj.vehcileObj.Vehicle_FullPlateNoAr}}</span>
                                                                                </label>
                                                                                <label *ngIf="false">
                                                                                        <span class="lbltext">{{ 'Plate Type' | translate}}:</span>
                                                                                        <span>{{Lng == "en"? prObj.vehcileObj.PlateTypeEn:prObj.vehcileObj.PlateTypeAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'vehicle Type'| translate}}:</span>
                                                                                        <span>{{Lng == "en"? prObj.vehcileObj.VechTypeEn: prObj.vehcileObj.VechTypeAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Make'| translate}}:</span>
                                                                                        <span>{{Lng == "en"? prObj.vehcileObj.VechileMakeEn:prObj.vehcileObj.VechileMakeAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{'Model'| translate}}:</span>
                                                                                        <span>{{Lng == "en"? prObj.vehcileObj.VechileModelEn :prObj.vehcileObj.VechileModelAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'ManufactureYear'| translate}}:</span>
                                                                                        <span>{{prObj.vehcileObj.Vehicle_ManfYear}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{'vehicle Color'| translate}}:</span>
                                                                                        <span>{{Lng == "en"? VehicleColorEn :VehicleColorAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{'Chasis No'| translate}}:</span>
                                                                                        <span>{{prObj.vehcileObj.Vehicle_ChassisNo}}</span>
                                                                                </label>

                                                                                <label>
                                                                                        <span *ngIf="prObj.vehcileObj.Vehicle_DefType==3" class="lbltext">{{'Custom Id'| translate}}:</span>
                                                                                        <span *ngIf="prObj.vehcileObj.Vehicle_DefType==2" class="lbltext">{{'Sequence No'| translate}}:</span>


                                                                                        <span>{{prObj.vehcileObj.Vehicle_DefType==2?prObj.vehcileObj.Vehicle_SequenceNo:prObj.vehcileObj.Vehicle_CustomId}}</span>
                                                                                </label>

                                                                        </div>

                                                                </div>
                                                        </div>
                                                        <div class="card" *ngIf="prObj.vehcileObj.MakeImageUrl!='' && prObj.vehcileObj.MakeImageUrl!=undefined">
                                                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                                                        <li role="presentation" class="active">
                                                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Vehicle Make'| translate}}</a>
                                                                        </li>

                                                                </ul>
                                                                <div style="display: flex;justify-content: center;">
                                                                        <img src="{{this.url.MakeImagebaseURL+prObj.vehcileObj.MakeImageUrl}}" style="width:50%; position: relative; top: 0px;" onerror="this.onerror=null; this.src='assets/img/NoImage.svg'">
                                                                </div>

                                                        </div>
                                                        <div class="card" style="width:100%;">
                                                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                                                        <li role="presentation" class="active">
                                                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{ 'Insured Information'| translate}}</a>
                                                                        </li>

                                                                </ul>
                                                                <div class="tab-content">
                                                                        <div role="tabpanel" class="tab-pane active PolicyInfo" id="home">
                                                                                <label>
                                                                                        <span class="lbltext">{{'Insured Name'| translate}}:</span>
                                                                                        <span class="InsurdNme">{{ prObj.Insured_Name}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Licence Expiry Date'| translate}}</span>
                                                                                        <span *ngIf="false">{{prObj.LicenceExpiryDate | date: 'dd/MM/yyyy' }}</span>
                                                                                        <span *ngIf="true">{{prObj.LicenceExpiryDateH}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Gender' | translate }}</span>
                                                                                        <span>{{Lng == "en"? InsGender :InsGenderAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Marital Status' | translate }}</span>
                                                                                        <span>{{Lng == "en"? InsMaritalStatus :InsMaritalStatusAr}}</span>
                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Date of birth' | translate }}</span>
                                                                                        <span>{{prObj.Insured_DOB_DS}}</span>

                                                                                </label>
                                                                                <label>
                                                                                        <span class="lbltext">{{ 'Nationality' | translate }}</span>
                                                                                        <span>{{Lng == "en"?InsNationality:InsNationalityAr}}</span>
                                                                                </label>

                                                                        </div>

                                                                </div>
                                                        </div>
                                                </div>

                                        </div>
                                </div>
                        </div>
                </div>
        </div>
</div>
<style>
        .PolicyInfo label span:first-child {
                width: 40% !important;
        }

        .InsurdNme {
                font-size: 9px !important;
        }

        .PolicyInfo label span:last-child {
                width: 58% !important;
        }

        .InsuredForm {
                padding: 15px 0px !important;
        }
</style>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/MotorProposalForm/MotorProposalForm.html